import React from "react";
import { Link } from "react-router-dom";
import "../styles/about.css";
import greenCoffeeBg from "../assets/images/Green_coffee_1.png";

export default function About() {
  return (
    <div className="about-page">
      {/* HERO SECTION */}
      <section className="about-hero"
      style={{
        backgroundImage: `linear-gradient(rgba(58, 38, 28, 0.85), rgba(58, 38, 28, 0.85)), url(${greenCoffeeBg})`
      }}
      >
        <div className="container">
          <span className="section-label light">Our Comapany</span>
          <h1 className="hero-title" id='about-hero-title'>
           About Aditya Exports Ventures
          </h1>
          <p className="hero-subtitle" id='about-hero-subtitle'>
              Established in 2025, Aditya Exports Ventures is an emerging Indian export company
              focused on supplying quality agricultural commodities to international markets.
              We specialize in sourcing premium coffee beans directly from trusted farms and
              processing units across India.
        </p>
          <p className="hero-subtitle" id='about-hero-subtitle'>
            Aditya Exports Ventures is committed to building long-term partnerships with
            roasters, traders, and importers by offering competitive pricing, transparent
            communication, and dependable supply, with a strong focus on global markets.
          </p>

          <p className="hero-subtitle" id='about-hero-subtitle'>
            Although newly established as a company, our operations are supported by
            experienced coffee growers, processors, and export logistics partners, enabling
            us to meet international quality standards and buyer specifications with
            confidence.
          </p>
        </div>
      </section>

      {/* EXPORT HIGHLIGHTS SECTION */}
<section className="about-highlights">
  <div className="container">
    <div className="highlights-grid">

      <div className="highlight-card">
        <h3 className="highlight-title">Export Experience</h3>
        <p className="highlight-text">
          Our team works closely with experienced coffee growers, processors, and
          export logistics partners to ensure smooth operations, consistent quality,
          and dependable international delivery.
        </p>
      </div>

      <div className="highlight-card">
        <h3 className="highlight-title">Product Strength</h3>
        <ul className="highlight-list">
          <li>Farm-sourced premium coffee</li>
          <li>Quality-controlled beans</li>
          <li>Complete traceability</li>
        </ul>
      </div>

    </div>
  </div>
</section>


      {/* STORY SECTION */}
      {/* <section className="about-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-image">
              <img src="https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=800" alt="Coffee Plantation" />
              <div className="experience-badge">
                <span className="years">15+</span>
                <p>Years of <br/> Excellence</p>
              </div>
            </div>
            <div className="story-content">
              <span className="section-label">Who We Are</span>
              <h2 className="section-title">Cultivating Trust & Quality</h2>
              <p className="lead-text">
                Founded in the heart of India's coffee belt, Aditya Exports Ventures began with a 
                simple mission: to bring the unique, bold, and spicy notes of Indian coffee 
                to the international stage.
              </p>
              <p>
                Today, we operate as a premier export house, sourcing beans from 
                Chikmagalur, Coorg, and the Baba Budan Hills. We handle every step of the 
                journey—from the cherry picking and processing to the final vacuum-sealed 
                shipment.
              </p>
              <div className="story-features">
                <div className="s-feat">
                  <strong>Ethical Sourcing</strong>
                  <p>Direct partnerships with local farmers ensuring fair trade practices.</p>
                </div>
                <div className="s-feat">
                  <strong>Traceability</strong>
                  <p>Every single bag can be traced back to its specific farm and harvest date.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* VISION & MISSION SECTION */}
      {/* <section className="vision-mission">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-card vision">
              <div className="vm-icon">👁️</div>
              <h3>Our Vision</h3>
              <p>
                To become the world's most trusted gateway for Indian Coffee, recognized 
                not just for volume, but for the uncompromising integrity of our beans 
                and the sustainability of our supply chain.
              </p>
            </div>
            <div className="vm-card mission">
              <div className="vm-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To empower Indian coffee farmers by providing global market access 
                while ensuring our international partners receive a product that 
                meets the highest standards of phytosanitary and flavor excellence.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* CORE VALUES */}
      {/* <section className="about-values">
        <div className="container">
          <div className="section-header text-center">
            <span className="section-label">Our DNA</span>
            <h2 className="section-title">Values That Drive Us</h2>
          </div>
          <div className="values-grid">
            <div className="value-item">
              <span className="v-num">01</span>
              <h4>Quality Obsession</h4>
              <p>We perform triple-check quality assessments on every batch before it leaves our warehouse.</p>
            </div>
            <div className="value-item">
              <span className="v-num">02</span>
              <h4>Legal Integrity</h4>
              <p>100% compliance with DGFT, Coffee Board, and international trade regulations.</p>
            </div>
            <div className="value-item">
              <span className="v-num">03</span>
              <h4>Global Logistics</h4>
              <p>Utilizing moisture-controlled shipping to ensure beans stay fresh across oceans.</p>
            </div>
            <div className="value-item">
              <span className="v-num">04</span>
              <h4>Sustainability</h4>
              <p>Promoting shade-grown practices that protect the biodiversity of our Western Ghats.</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* FINAL CTA */}
      <section className="about-cta">
        <div className="container text-center">
          <h2>Experience the Aditya Exports Ventures Standard</h2>
          <h5>Join our network of global partners and discover why Indian Coffee is the industry's best kept secret.</h5>
          <div className="cta-btns">
            <Link to="/coffee/roasted" className="btn-coffee-primary">Explore Our Varieties</Link>
            <Link to="/contact#contact-form" className="btn-coffee-outline">Partner With Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}